
export class AsgardPane {
    index: number;
    isActive: boolean;
    constructor(index: number) {
        this.isActive = true;
        this.index = index;
    }

    setActivePane(): void {
        this.isActive = true;
    }

    destoryPane(): void {
        console.log('destoryPane');
    }
}
